import PropTypes from "prop-types";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@material-ui/core";
import RefreshIcon from "@mui/icons-material/Refresh";
import VisibilityIcon from "@mui/icons-material/Visibility";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";

import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import { columnTextField, sortableField } from "utils/tables-utils";

export default function TableColetas({
  data,
  totalRegistros,
  page,
  pageSize,
  onTableChange,
  onRefresh,
  onViewDetails,
  onExport,
  exporting,
  exportProgress,
}) {
  const columnModel = [
    sortableField({
      dataField: "dataEnvioFormat",
      text: "Envio",
      align: "center",
    }),
    sortableField({
      dataField: "dataColeta",
      text: "Data coleta",
      align: "center",
    }),
    sortableField({
      dataField: "lojaRazaoSocial",
      text: "Loja",
      align: "center",
    }),
    sortableField({
      dataField: "representante",
      text: "Representante",
      align: "center",
    }),
    sortableField({
      dataField: "sku",
      text: "SKU",
      align: "center",
    }),
    sortableField({
      dataField: "marca",
      text: "Marca",
      align: "center",
    }),
    sortableField({
      dataField: "produtoNome",
      text: "Produto",
      align: "center",
    }),
    sortableField({
      dataField: "precoMarcaFormat",
      text: "Preço na loja",
      align: "center",
    }),
    sortableField({
      dataField: "tipoColeta",
      text: "Tipo",
      align: "center",
    }),
    columnTextField({
      dataField: "qtdConcorrentes",
      text: "Concorrentes",
      align: "center",
    }),
    columnTextField({
      dataField: "acoes",
      text: "Ações",
      align: "center",
      formatter: (_, row) => (
        <Tooltip title="Visualizar detalhes">
          <IconButton
            size="small"
            onClick={() => onViewDetails?.(row.detalhe)}
            aria-label="Visualizar detalhes"
          >
            <VisibilityIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      ),
    }),
  ];

  const exportLabel = exporting
    ? exportProgress?.total
      ? `Exportando (${exportProgress.loaded}/${exportProgress.total})...`
      : "Exportando..."
    : "Exportar para Excel";

  return (
    <ToolkitTable
      keyField="idColeta"
      dataTable={data}
      columnModel={columnModel}
      searched
      allowEmpty
      notFoundTitle="Nenhuma coleta encontrada."
      bootstrapTableProps={{
        remote: true,
        onTableChange: onTableChange,
      }}
      pagination={{
        options: [10, 25, 50],
        defaultOption: 25,
        showTotal: true,
        totalSize: totalRegistros,
        page,
        sizePerPage: pageSize,
      }}
      CustomHeader={() => (
        <Grid
          container
          justify="space-between"
          alignItems="center"
          spacing={2}
          style={{ padding: "0 20px 20px 20px" }}
        >
          <Grid item>
            <Box display="flex" alignItems="center">
              <Typography component="h2" variant="h2">
                Histórico de coletas
              </Typography>

              {onRefresh && (
                <Tooltip title="Atualizar">
                  <IconButton
                    size="small"
                    onClick={onRefresh}
                    aria-label="Atualizar"
                    disabled={exporting}
                    style={{ marginLeft: 8 }}
                  >
                    <RefreshIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          </Grid>
          <Grid item>
            <Button
              variant="outlined"
              size="small"
              startIcon={
                exporting ? (
                  <CircularProgress size={16} color="inherit" />
                ) : (
                  <FileDownloadOutlinedIcon fontSize="small" />
                )
              }
              onClick={onExport}
              disabled={exporting || totalRegistros === 0}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {exportLabel}
            </Button>
          </Grid>
        </Grid>
      )}
    />
  );
}

TableColetas.propTypes = {
  data: PropTypes.array.isRequired,
  totalRegistros: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  onTableChange: PropTypes.func.isRequired,
  onRefresh: PropTypes.func,
  onViewDetails: PropTypes.func,
  onExport: PropTypes.func,
  exporting: PropTypes.bool,
  exportProgress: PropTypes.shape({
    loaded: PropTypes.number,
    total: PropTypes.number,
  }),
};
